  <template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New ARM</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit ARM</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query ARM</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.arm }}</v-subheader>
                <div class="queryValue">{{ form.arm }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  :label="labels.arm"
                  v-model="form.arm"
                  :error-messages="errors.collect('arm')"
                  data-vv-name="arm"
                  :data-vv-as="labels.arm"
                  v-validate="'required|max:8'"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.armName }}</v-subheader>
                <div class="queryValue">{{ form.armName }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  :label="labels.armName"
                  v-model="form.armName"
                  :error-messages="errors.collect('armName')"
                  data-vv-name="armName"
                  :data-vv-as="labels.armName"
                  v-validate="'required|max:30'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.sector }}</v-subheader>
                <div class="queryValue">{{ form.sector }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.sector"
                  :items="sectorList"
                  v-model="form.sector"
                  item-text="value"
                  item-value="code"
                  data-vv-name="sector"
                  :data-vv-as="labels.sector"
                  :error-messages="errors.collect('sector')"
                  v-validate="'required'"
                  @input="doDivision"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.division }}</v-subheader>
                <div class="queryValue">{{ form.division }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.division"
                  :items="divisionList"
                  v-model="form.division"
                  item-text="value"
                  item-value="code"
                  data-vv-name="division"
                  :data-vv-as="labels.division"
                  :error-messages="errors.collect('division')"
                  v-validate="'required'"
                  @input="doTeam"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.team }}</v-subheader>
                <div class="queryValue">{{ form.team }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.team"
                  :items="teamList"
                  v-model="form.team"
                  item-text="value"
                  item-value="code"
                  data-vv-name="team"
                  :data-vv-as="labels.team"
                  :error-messages="errors.collect('team')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6> </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
              {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        arm: 'ARM',
        armName: 'ARM Name',
        sector: 'Sector',
        division: 'Division',
        team: 'Team',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        arm: '',
        armName: '',
        division: '',
        sector: '',
        team: ''
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      sectorList: [],
      divisionList: [],
      teamList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetchSector() {
      const apiURI = this.menu.sectorList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiURI))
          const { data } = result.data
          this.sectorList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.value,
                value: datamap.label
              }
              this.sectorList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchDivision(sec) {
      const apiURI = this.menu.divisionList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            sector: sec
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.divisionList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.value,
                value: datamap.label
              }
              this.divisionList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchTeam(div, sec) {
      const apiURI = this.menu.teamList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            division: div,
            sector: sec
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.teamList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.value,
                value: datamap.label
              }
              this.teamList.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetch() {
      const apiURI = this.menu.getSchemeArm
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            if (this.modeParam === 'review') {
              this.doFetchDivision(data.schemeArm.sector)
              this.doFetchTeam(data.schemeArm.division, data.schemeArm.sector)
            }
            this.form.arm = data.schemeArm.arm
            this.form.armName = data.schemeArm.armName
            this.form.sector = data.schemeArm.sector
            this.form.division = data.schemeArm.division
            this.form.team = data.schemeArm.team
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'arm' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      if (this.divisionList.length === 0) {
        this.form.division = ''
      }
      if (this.teamList.length === 0) {
        this.form.team = ''
      }
      const apiURI = this.menu.createSchemeArm
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      if (this.divisionList.length === 0) {
        this.form.division = ''
      }
      if (this.teamList.length === 0) {
        this.form.team = ''
      }
      const apiURI = this.menu.updateSchemeArm
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doDivision() {
      if (this.form.sector) {
        this.doFetchDivision(this.form.sector)
      }
    },
    doTeam() {
      if (this.form.division && this.form.sector) {
        this.doFetchTeam(this.form.division, this.form.sector)
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.boIncenSchParam.arm.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    filterSectorList() {
      return this.polTypeList.filter((list) => {
        return list.code === this.form.polType
      })
    }
  },
  created() {
    this.doFetchSector()
    if (this.modeParam === 'create') {
      this.newMode = true
      this.doFetchDivision('')
      this.doFetchTeam('', '')
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  async mounted() {
    await this.$store.dispatch('armInit')
  },
  mixins: [MessageMixin]
}
</script>
